<svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="4.5" y="4" width="10" height="10" rx="1" fill="#7489D8"/>
<rect x="4.5" y="18" width="10" height="10" rx="1" fill="#7489D8"/>
<rect x="18.5" y="4" width="10" height="10" rx="1" fill="#7489D8"/>
<rect x="18.5" y="18" width="10" height="10" rx="1" fill="#7489D8"/>
</svg>
